<div class="layout-row layout-align-start-center gap-5"
     [class.pointer]="blockedCount || relatedCount"
     (click)="onIndicatorClick($event)">
  <bringoz-icon iconName="relation"
                classSize="md"
                fill="#484848"
                [ngbTooltip]="'Relations' | translate"
                openDelay="300">
  </bringoz-icon>
  <div *ngIf="blockedCount || relatedCount; else noRelations" class="layout-row layout-align-start-center gap-5">
    <app-bringoz-tag *ngIf="blockedCount"
                      [isHideTooltip]="true"
                      [color]="'#FF88C1'"
                      [backgroundColor]="'#FFEDF6'"
                      [name]="blockedCount + ' ' + ('TASK_RELATIONS_BLOCKED_SHORT' | translate)">
    </app-bringoz-tag>
    <app-bringoz-tag *ngIf="relatedCount"
                      [isHideTooltip]="true"
                      [color]="'#AD76E3'"
                      [backgroundColor]="'#F0EAF6'"
                      [name]="relatedCount + ' ' + ('TASK_RELATIONS_RELATED_SHORT' | translate)">
    </app-bringoz-tag>
  </div>
  <ng-template #noRelations>
    <span class="md-tiny no-relations">---</span>
  </ng-template>
</div>
